import SpecialistReviewAPI from "api/SpecialistReviewAPI";
import useFetchData from "hooks/useFetchData";

export default function useSpecialistReviewsAny( params: SpecialistReviewsGETPaginatedParams = {}) {
   return useFetchData({
      APIMethod: SpecialistReviewAPI.getAllAny,
      params: [ params ],
      debounce: true,
      clear_data_on_update: true
   })
}